import React, { useEffect, useState } from 'react'
import { goPayPasargadFakeGate } from '../actions/orderActions'
import { Row, Col, Button, ListGroup, Card, Form } from 'react-bootstrap'
import PersianText from '../components/PersianText'
import Message from '../components/Message'



function OrderGeneralScreen() {

    // handle pay order
    const [payGateMessage, setPayGateMessage] = useState('')

    const [selectedOption, setSelectedOption] = useState(""); // ذخیره گزینه انتخاب‌شده

    const [selectedCode, setselectedCode] = useState("")
    const [selectedAddress, setselectedAddress] = useState("")

    // لیست آیتم‌ها (عنوان، قیمت و شناسه)
    const items = [
        { id: 1, title: 'کیت انشعاب سایز 1/2', price: 161523835, description: 'این بسته شامل تمام لوازم انشعاب سایز 1/2 اینج است .' },
        { id: 2, title: 'کیت انشعاب سایز 3/4', price: 204737364, description: 'این بسته شامل تمام لوازم انشعاب سایز 3/4 اینج است .' },
        { id: 3, title: 'کیت انشعاب سایز 1', price: 322218793, description: 'این بسته شامل تمام لوازم انشعاب سایز 1 اینج است .' },
    ];

    // نگهداری شناسه آیتم انتخاب‌شده (به‌طور پیش‌فرض آیتم اول)
    const [selectedPlanId, setSelectedPlanId] = useState(items[0].id);

    const handlePayment = (e) => {
        e.preventDefault()//صفحه ریلود نمیشود
        if (!selectedAddress) {
            alert("لطفا آدرس را وارد کنید");
        } else if (!selectedCode) {
            alert("لطفا کد پستی  را وارد کنید");
        } else {

            //     goPayGate(orderId, order.kit.gov_price, selectedAddress, selectedCode)
            //         .then(function (response) {
            //             window.location.assign(`https://www.zarinpal.com/pg/StartPay/` + response.data.data.authority)
            //         }).catch(function (error) {
            //             if (error.response.data && error.response.data.detail) {
            //                 setPayGateMessage(error.response.data.detail)
            //             } else {
            //                 setPayGateMessage(error.response.data)
            //             }
            //         })
            // }
            // const selectedItem = items.find((item) => item.id === Number(selectedPlanId));
            // goPayPasargadFakeGate(selectedItem.price)
            //     .then(function (response) {
            //         window.location.assign(response.data)
            //     }).catch(function (error) {
            //         if (error.response.data && error.response.data.detail) {
            //             setPayGateMessage(error.response.data.detail)
            //         } else {
            //             setPayGateMessage(error.response.data)
            //         }
            //     })
        }

        setSelectedOption('')
        setselectedAddress('')
        setselectedCode('')

    }


    return (<div>
        <h1>
            <Form.Group controlId='trackcode1' className="d-flex align-items-center gap-2">
                <Form.Label className="mb-0">
                    <PersianText>سفارش شماره :</PersianText>
                </Form.Label>
                <Form.Control
                    type='text'
                    name="option"
                    style={{ maxWidth: '200px' }} // برای کنترل عرض تکست‌باکس در صورت نیاز
                />
            </Form.Group>
        </h1>
        <hr />

        <Row>
            <Col md={6}>
                <ListGroup variant="flush" className="border rounded shadow-sm">
                    {/* بخش مشخصات فردی */}
                    <ListGroup.Item className="p-3">
                        <h5 className="mb-3 text-primary fw-bold">مشخصات تحویل‌گیرنده</h5>

                        <div className="d-flex flex-column gap-3">
                            {/* نام و نام خانوادگی */}
                            <Form.Group controlId="fullName" className="d-flex align-items-center">
                                <Form.Label className="mb-0 text-nowrap" style={{ minWidth: '130px' }}>
                                    <PersianText>نام و نام خانوادگی:</PersianText>
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    name="fullName"
                                    className="flex-grow-1"
                                />
                            </Form.Group>

                            {/* تلفن تماس */}
                            <Form.Group controlId="phoneNumber" className="d-flex align-items-center">
                                <Form.Label className="mb-0 text-nowrap" style={{ minWidth: '130px' }}>
                                    <PersianText>تلفن تماس:</PersianText>
                                </Form.Label>
                                <Form.Control
                                    type="tel"
                                    name="phoneNumber"
                                    className="flex-grow-1"
                                />
                            </Form.Group>
                        </div>
                    </ListGroup.Item>

                    {/* بخش آدرس و کد پستی */}
                    <ListGroup.Item className="p-3">
                        {/* باکس پیام راهنما/هشدار */}
                        <div className="alert alert-warning py-2 px-3 mb-3 small text-justify" role="alert">
                            <strong>توجه: </strong>
                            در وارد کردن آدرس و کد پستی دقت کنید. بسته‌بندی لوازم از طریق پست رایگان ارسال می‌شود؛ در صورت اشتباه بودن آدرس یا کدپستی، هزینه تحویل از انبار نجف‌آباد و ارسال مجدد به عهده مشترک خواهد بود.
                        </div>

                        {/* فیلد آدرس */}
                        <Form.Group controlId="address" className="mb-3">
                            <Form.Label className="fw-semibold mb-1">
                                <PersianText>آدرس دقیق پستی:</PersianText>
                            </Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                name="address"
                                value={selectedAddress}
                                onChange={(e) => setselectedAddress(e.target.value)}
                            />
                        </Form.Group>

                        {/* فیلد کد پستی */}
                        <Form.Group controlId="postalCode">
                            <Form.Label className="fw-semibold mb-1">
                                <PersianText>کد پستی (۱۰ رقمی):</PersianText>
                            </Form.Label>
                            <Form.Control
                                type="text"
                                maxLength={10}
                                name="postalCode"
                                value={selectedCode}
                                onChange={(e) => setselectedCode(e.target.value)}
                            />
                        </Form.Group>
                    </ListGroup.Item>
                </ListGroup>
            </Col>
            <Col md={6}>
                <Card className="shadow-sm p-4">
                    <h4 className="mb-4">انتخاب کیت و پرداخت</h4>

                    <Form onSubmit={handlePayment}>
                        <div className="d-flex flex-column gap-3 mb-4">
                            {items.map((item) => (
                                <Card
                                    key={item.id}
                                    className={`p-3 border transition-all ${selectedPlanId === item.id ? 'border-primary bg-light' : 'border-secondary-subtle'
                                        }`}
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => setSelectedPlanId(item.id)}
                                >
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center gap-3">
                                            <Form.Check
                                                type="radio"
                                                id={`plan-${item.id}`}
                                                name="paymentPlan"
                                                value={item.id}
                                                checked={selectedPlanId === item.id}
                                                onChange={(e) => setSelectedPlanId(Number(e.target.value))}
                                            />
                                            <div>
                                                <h6 className="mb-0 fw-bold">{item.title}</h6>
                                                <small className="text-muted">{item.description}</small>
                                            </div>
                                        </div>

                                        <div className="text-primary fw-bold">
                                            {item.price.toLocaleString('fa-IR')} ریال
                                        </div>
                                    </div>
                                </Card>
                            ))}
                        </div>
                        <ListGroup variant='flush'>
                            <ListGroup.Item className={payGateMessage ? '' : 'd-none'}>
                                <Message variant='danger' text={payGateMessage} />
                            </ListGroup.Item>
                        </ListGroup>

                        <div className="d-flex justify-content-end">
                            <Button variant="success" size="lg" type="submit" className="px-4">
                                پرداخت و تکمیل سفارش
                            </Button>
                        </div>
                    </Form>
                </Card>
            </Col>
        </Row>

    </div>

    )
}

export default OrderGeneralScreen
